import { render, staticRenderFns } from "./TipoDocumentoListagemBotoesAcoes.vue?vue&type=template&id=65a07a85&scoped=true"
import script from "./TipoDocumentoListagemBotoesAcoes.vue?vue&type=script&lang=js"
export * from "./TipoDocumentoListagemBotoesAcoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a07a85",
  null
  
)

export default component.exports